import { useCallback, useEffect, useRef, useState } from "react"
import util from "../../utils/util";
import orderManager from "../../manager/order";
import EventBus from "../../utils/EventBus";
import View from "../../components/Base/View";
import Text from "../../components/Base/Text";
import Block from "../../components/Base/Block";
import Image from "../../components/Base/Image";
import Productinfoinorder from "../../components/ProductInfoInOrder";
import './order.scss'
import rm from "../../utils/rm";
import { toast } from "../../utils/toast";
import PayOrderPanel, { PayOrderPanelRef } from "../../components/PayOrderPanel";
import tool from "../../utils/addressUtil";
import RefundRequestDialog, { RefundRequestDialogRef } from "../../components/RefundRequestDialog";
import ShipmentListModal, { ShipmentListModalRef } from "../../components/ShipmentListModal";

const Order = () => {

    const [orderInfo, setOrderInfo] = useState<any>();
    const [ShippingAddress, setShippingAddress] = useState<any>();
    const payOrderRef = useRef<PayOrderPanelRef>()

    const isOperating = useRef<boolean>(false);

    const refundDialogRef = useRef<RefundRequestDialogRef>();
    const shipmentDialogRef = useRef<ShipmentListModalRef>();

    const loadOrderInfo = useCallback((orderId: number, checkState?: boolean) => {
        if (orderId) {
            orderManager.getOrderDetail(
                orderId,
                checkState,
                function (success: boolean, orderInfo: any, tips: string) {
                    var orderData = orderInfo
                    orderData.CreatedOnTimeArray = util.getTimeArry(orderData.CreatedOn) //下单时间
                    orderData.PaidDateTimeArray = util.getTimeArry(orderData.PaidDate) //付款时间
                    orderData.ShippedTimeArray = util.getTimeArry(orderData.ShippedTime) //发货时间
                    orderData.ConfirmTimeArray = util.getTimeArry(orderData.ConfirmTime) //确认收货时间

                    if (orderData.AutoCloseUnpayedMinutes) {
                        orderData.leftTimeStr = util.getLeftTimeStr(
                            orderData.CreatedOn,
                            orderData.AutoCloseUnpayedMinutes
                        )
                    }
                    setOrderInfo(orderData)
                    setShippingAddress(orderData.ShippingAddress)
                }
            )
        }
    }, [])

    useEffect(() => {
        document.title = "订单详情";
        const urlInfo = util.parasUrl(window.location.href);
        const orderId = (urlInfo.params as any).id as number;
        const needCheckState = !!(urlInfo.params as any).checkstate;
        if (orderId) {
            loadOrderInfo(orderId, needCheckState)
        }

        // const onAddRessSelect = function (addressInfo: any) {
        //     setShippingAddress(addressInfo)
        // }

        const onSubmitAftersale = function (info: any) {
            if (info.orderId == orderId) {
                loadOrderInfo(orderId)
            }
        }
        // EventBus.register(EventBus.names.ADDRESS_SELECTED, onAddRessSelect)
        EventBus.register(EventBus.names.SUBMIT_AFTERSALE_SUCCESS, onSubmitAftersale)
        return () => {
            // EventBus.unregister(EventBus.names.ADDRESS_SELECTED, onAddRessSelect)
            EventBus.unregister(EventBus.names.SUBMIT_AFTERSALE_SUCCESS, onSubmitAftersale)
        }
    }, [])

    const openShipmentListDialog = (productInfo: any) => {
        if (!util.allowClick()) {
            return
        }
        shipmentDialogRef.current?.open(productInfo)
        // TODO: 查看物流 this.selectComponent('.shipmentListModal').open(e.detail)
    }

    const refundOrder = () => {
        if (!util.allowClick()) {
            return;
        }
        refundDialogRef.current?.open(orderInfo);
    }

    /**
     * 取消订单
     * @returns 
     */
    const cancelOrder = () => {
        if (!util.allowClick()) {
            return
        }
        if (isOperating.current) {
            return
        }
        rm.showModal({
            title: '确定取消此订单？',
            content: '',
            showCancel: true,
            cancelText: '不取消',
            confirmText: '确定',
            cancelColor: '#333333',
            confirmColor: '#e74737',
        }, (res) => {
            if (res.confirm) {
                toast.loading('订单取消中', 0, "cancel")
                isOperating.current = true;
                orderManager.cancelOrder(
                    orderInfo.Id,
                    function (success: boolean, data: any, tips: string) {
                        if (success) {
                            // var orderInfo = that.data.orderInfo;
                            // orderInfo.OrderStatus = "已取消";
                            // orderInfo.OrderStatusId = 50;
                            // that.setData({
                            //   orderInfo: orderInfo
                            // })
                            rm.redirectTo({
                                url: '/order/order?id=' + orderInfo.Id + '&checkstate=1',
                            })
                        }
                        toast.destory("cancel")
                        toast.info(tips)
                        isOperating.current = false;
                    }
                )
            }
        })
    }

    /**
     * 支付订单
     * @returns 
     */
    const payOrder = () => {
        if (!util.allowClick()) {
            return
        }
        if (isOperating.current) {
            return
        }
        isOperating.current = true;
        var payParam = {
            OrderId: orderInfo.Id,
            CustomerWxOpenIdObtained: false,
            OrderInfo: orderInfo,
        }

        payOrderRef.current?.request(payParam, (state: string, data: any, tips: string)=>{
            toast.info(tips)
            isOperating.current = false;
            if (state === 'success') {
                rm.redirectTo({
                    url: '/order/order?id=' + orderInfo.Id + '&checkstate=1',
                })
            }
        })
    }

    /**
     * 延迟收货
     */
    const delayOrder = () => {
        if (!util.allowClick()) {
            return
        }
        if (isOperating.current) {
            return
        }
        rm.showModal({
            title: '确定要延迟收货？',
            content: '',
            showCancel: true,
            cancelText: '取消',
            confirmText: '确定',
            cancelColor: '#333333',
            confirmColor: '#e74737',
        }, (res) => {
            if (res.confirm) {
                isOperating.current = true;
                toast.loading('处理中', 0, "delayOrder")
                orderManager.delayAutoConfirm(
                    orderInfo.Id,
                    function (success: boolean, data: any, tips: string) {
                        if (success) {
                            rm.redirectTo({
                                url:
                                    '/order/order?id=' +
                                    orderInfo.Id +
                                    '&checkstate=1'
                            })
                        }
                        toast.destory("delayOrder")
                        toast.info(tips)
                        isOperating.current = false;
                    }
                )
            }
        })
    }

    /**
     * 确认收货
     */
    const confirmOrder = () => {
        if (!util.allowClick()) {
            return
        }
        if (isOperating.current) {
            return
        }
        rm.showModal({
            title: '是否确认收货？',
            content: '',
            showCancel: true,
            cancelText: '取消',
            confirmText: '确定',
            cancelColor: '#333333',
            confirmColor: '#e74737',
        }, (res) => {
            if (res.confirm) {
                isOperating.current = true;
                toast.loading('处理中', 0, "confirmOrder")
                orderManager.confirmOrder(
                    orderInfo.Id,
                    function (success: boolean, data: any, tips: string) {
                        if (success) {
                            rm.redirectTo({
                                url:
                                    '/order/order?id=' +
                                    orderInfo.Id +
                                    '&checkstate=1',

                            })
                        }
                        toast.destory("confirmOrder")
                        toast.info(tips)
                        isOperating.current = false;
                    }
                )
            }
        })
    }

    /**
     * 删除订单
     */
    const deleteOrder = () => {
        toast.info("开发中")
    }

    const buyAgain = () => {
        if (!util.allowClick()) {
            return
        }
        util.navigateTo(
            '/order/checkout?isrmmp=1&hidemenu=1&reorderid=' + orderInfo.Id
        )
    }

    if (!orderInfo) {
        return null;
    }

    return <View className="order-page">
        {ShippingAddress && ShippingAddress?.Id > 0 && (
            <View className="order-address flex-conainer">
                <View className="flex-grow">
                    <Text className="user-name">
                        {ShippingAddress.Name +
                            '  ' +
                            tool.getDisplayPhoneNumber(ShippingAddress.PhoneNumber)}
                    </Text>
                    <Text className="user-address">
                        {tool.getFullAddress(ShippingAddress)}
                    </Text>
                </View>
                <Image
                    style={{
                        display: 'none',
                    }}
                    className="setting-style-arrow"
                    src={require('../../images/right-arrow.png')}
                ></Image>
            </View>
        )}
        {ShippingAddress && ShippingAddress?.Id > 0 && (
            <View className="order-address-border"></View>
        )}
        {/*  商品信息  */}
        {orderInfo.Items.map((productInfo: any, index: number) => {
            return (
                <Block key={productInfo.Id}>
                    <Productinfoinorder
                        productInfo={productInfo}
                        orderInfo={orderInfo}
                        clickToProductDetail={true}
                        showBottomBorder={
                            !(
                                (orderInfo.OrderStatusId == 10 ||
                                    orderInfo.OrderStatusId == 50) &&
                                index == orderInfo.Items.length - 1
                            )
                        }
                        onRequestOpenShipmentDialog={openShipmentListDialog}
                    ></Productinfoinorder>
                    {/*  申请售后  */}
                    {(orderInfo.OrderStatusId == 30 ||
                        orderInfo.OrderStatusId == 40) &&
                        !productInfo.NotReturnable && (
                            <View
                                className={
                                    'flex-conainer btns-container ' +
                                    (index != orderInfo.Items.length - 1
                                        ? 'btns-container-border'
                                        : '')
                                }
                            >
                                <View className="flex-grow"></View>
                                {productInfo.HasReturnRequest && (
                                    <View
                                        className="flex-fix service-btn"
                                        data-itemid={productInfo.Id}
                                        onClick={() => {
                                            if (!util.allowClick()) {
                                                return
                                            }
                                            util.navigateTo(
                                                '/aftersale/list?isrmmp=1&hidemenu=1&orderitemid=' + productInfo.Id
                                            )
                                        }}
                                    >
                                        查看售后
                                    </View>
                                )}
                                <View
                                    className="flex-fix service-btn"
                                    data-itemid={productInfo.Id}
                                    onClick={() => {
                                        if (!util.allowClick()) {
                                            return
                                        }
                                        util.navigateTo(
                                            '/aftersale/submit?isrmmp=1&hidemenu=1&id=' + orderInfo.Id +
                                            '&itemid=' + productInfo.Id
                                        )
                                    }}
                                >
                                    申请售后
                                </View>
                            </View>
                        )}
                </Block>
            )
        })}
        {/*  优惠券、发票  */}
        <View className="other-options setting-style-pannel">
            <View className="flex-conainer setting-style-item order-note">
                <Text className="flex-fix">买家留言</Text>
                <Text className="flex-grow setting-style-des order-note-content">
                    {orderInfo.CustomerNote ? orderInfo.CustomerNote : '无'}
                </Text>
            </View>
        </View>
        {/*  支付信息  */}
        <View className="pay-info setting-style-pannel">
            <View className="flex-conainer setting-style-item">
                <Text className="flex-grow">订单总价</Text>
                <Text>{orderInfo.OrderSubtotal}</Text>
            </View>
            {orderInfo.OrderTotalDiscount != null && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">优惠券</Text>
                    <Text>
                        {orderInfo.OrderTotalDiscount != null
                            ? orderInfo.OrderTotalDiscount
                            : '-¥0'}
                    </Text>
                </View>
            )}
            {orderInfo.RedeemedRewardPoints > 0 && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">金币抵扣</Text>
                    <Text>
                        {orderInfo.RedeemedRewardPoints > 0
                            ? orderInfo.RedeemedRewardPointsAmount
                            : '-¥0'}
                    </Text>
                </View>
            )}
            {orderInfo.IsShippable && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">运费</Text>
                    <Text>{orderInfo.OrderShipping}</Text>
                </View>
            )}
            <View className="flex-conainer setting-style-item">
                <Text className="flex-grow">实付款</Text>
                <Text className="setting-style-value">{orderInfo.OrderTotal}</Text>
            </View>
            {orderInfo.OrderRefundedAmout != null && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">售后退款</Text>
                    <Text className="setting-style-value">
                        {orderInfo.OrderRefundedAmout}
                    </Text>
                </View>
            )}
            {orderInfo.RewardPointEarned != null &&
                orderInfo.RewardPointEarned > 0 && (
                    <View className="confirm-point-container">
                        <View className="confirm-point-earn">
                            <Text>确认收货返</Text>
                            <Text className="confirm-point-earn-value">
                                {orderInfo.RewardPointEarned + ' 金币'}
                            </Text>
                        </View>
                    </View>
                )}
            <View
                className="flex-conainer setting-style-item"
                style={{
                    display: 'none',
                }}
            >
                <Text className="flex-grow">支付方式</Text>
                <View>
                    <Text>微信支付</Text>
                </View>
                <Image
                    className="setting-style-arrow"
                    src={require('../../images/right-arrow.png')}
                ></Image>
            </View>
        </View>
        {/*  订单编号、时间等信息  */}
        <View className="order-time setting-style-pannel">
            <View className="flex-conainer setting-style-item">
                <Text className="flex-grow">
                    {'订单编号：' + orderInfo.CustomOrderNumber}
                </Text>
                <View
                    className="flex-fix copy-order-num-btn"
                    onClick={() => {
                        rm.setClipboardData(`${orderInfo.CustomOrderNumber}`, (res) => {
                            toast.success("复制成功")
                        })
                    }}
                >
                    复制
                </View>
            </View>
            <View className="flex-conainer setting-style-item">
                <Text className="flex-grow">
                    {'下单时间：' +
                        orderInfo.CreatedOnTimeArray[0] +
                        '-' +
                        orderInfo.CreatedOnTimeArray[1] +
                        '-' +
                        orderInfo.CreatedOnTimeArray[2] +
                        ' ' +
                        orderInfo.CreatedOnTimeArray[3] +
                        ':' +
                        orderInfo.CreatedOnTimeArray[4] +
                        ':' +
                        orderInfo.CreatedOnTimeArray[5]}
                </Text>
            </View>
            {orderInfo.PaidDate != null && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">
                        {'付款时间：' +
                            orderInfo.PaidDateTimeArray[0] +
                            '-' +
                            orderInfo.PaidDateTimeArray[1] +
                            '-' +
                            orderInfo.PaidDateTimeArray[2] +
                            ' ' +
                            orderInfo.PaidDateTimeArray[3] +
                            ':' +
                            orderInfo.PaidDateTimeArray[4] +
                            ':' +
                            orderInfo.PaidDateTimeArray[5]}
                    </Text>
                </View>
            )}
            {orderInfo.ShippedTime != null && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">
                        {'发货时间：' +
                            orderInfo.ShippedTimeArray[0] +
                            '-' +
                            orderInfo.ShippedTimeArray[1] +
                            '-' +
                            orderInfo.ShippedTimeArray[2] +
                            ' ' +
                            orderInfo.ShippedTimeArray[3] +
                            ':' +
                            orderInfo.ShippedTimeArray[4] +
                            ':' +
                            orderInfo.ShippedTimeArray[5]}
                    </Text>
                </View>
            )}
            {orderInfo.ConfirmTime != null && (
                <View className="flex-conainer setting-style-item">
                    <Text className="flex-grow">
                        {'确认时间：' +
                            orderInfo.ConfirmTimeArray[0] +
                            '-' +
                            orderInfo.ConfirmTimeArray[1] +
                            '-' +
                            orderInfo.ConfirmTimeArray[2] +
                            ' ' +
                            orderInfo.ConfirmTimeArray[3] +
                            ':' +
                            orderInfo.ConfirmTimeArray[4] +
                            ':' +
                            orderInfo.ConfirmTimeArray[5]}
                    </Text>
                </View>
            )}
        </View>
        <View
            className={
                'flex-conainer bottom-tool padding-safe-area'
            }
        >
            <View className="flex-grow order-status">
                {orderInfo.OrderStatusId == 10 ? (
                    <Block>{orderInfo.leftTimeStr}</Block>
                ) : orderInfo.OrderStatusId == 20 &&
                    orderInfo.CancelRequestStatusId != 0 ? (
                    <Block>{orderInfo.CancelRequestStatus}</Block>
                ) : (
                    <Block>{orderInfo.OrderStatus}</Block>
                )}
                {/*  退款申请中、申请退款处理完成  */}
                {/*  其他，显示订单状态  */}
            </View>
            {orderInfo.OrderStatusId == 10 && (
                <View
                    className="flex-fix bottom-btn cancel-btn"
                    onClick={cancelOrder}
                >
                    取消订单
                </View>
            )}
            {orderInfo.OrderStatusId == 10 && (
                <PayOrderPanel
                ref={payOrderRef}>
                    <View
                        className="flex-fix bottom-btn buy-btn"
                        onClick={payOrder}
                    >
                        支付订单
                    </View>
                </PayOrderPanel>
            )}
            {orderInfo.OrderStatusId == 20 && (
                <View
                    className="flex-fix bottom-btn refund-btn"
                    onClick={refundOrder}
                >
                    {orderInfo.CancelRequestStatusId == 1 ? (
                        <Block>查看退款进度</Block>
                    ) : orderInfo.CancelRequestStatusId == 2 ? (
                        <Block>查看退款结果</Block>
                    ) : (
                        <Block>申请退款</Block>
                    )}
                </View>
            )}
            {orderInfo.OrderStatusId == 30 && (
                <View
                    className="flex-fix bottom-btn delay-btn"
                    onClick={delayOrder}
                >
                    延长收货
                </View>
            )}
            {orderInfo.OrderStatusId == 30 && (
                <View
                    className="flex-fix bottom-btn confirm-btn-new"
                    onClick={confirmOrder}
                >
                    确认收货
                </View>
            )}
            {(orderInfo.OrderStatusId == 40 || orderInfo.OrderStatusId == 50) && (
                <View
                    className="flex-fix bottom-btn delete-btn"
                    onClick={deleteOrder}
                    style={{
                        display: 'none',
                    }}
                >
                    删除订单
                </View>
            )}
            {/*  && orderInfo.IsReOrderAllowed  */}
            {(orderInfo.OrderStatusId == 40 || orderInfo.OrderStatusId == 50) && (
                <View
                    className="flex-fix bottom-btn rebuy-btn"
                    onClick={buyAgain}
                >
                    再次购买
                </View>
            )}
        </View>

        {/* TODO */}
        <RefundRequestDialog ref={refundDialogRef}></RefundRequestDialog>
        <ShipmentListModal ref={shipmentDialogRef}/>
    </View>

}

export default Order;